import request from "@/utils/request";

export function changeStatusForApprove(params) {
  return request({
    url: "/v2/sec/contractDetail/changeStatusForApprove",
    method: "post",
    data: params
  });
}

export function verifyChain(params) {
  return request({
    url: "/v2/sec/contractDetail/verifyChain",
    method: "post",
    data: params
  });
}

export function changeStatusForReviewApprove(params) {
  return request({
    url: "/v2/sec/contractDetail/changeStatusForReviewApprove",
    method: "post",
    data: params
  });
}

export function approvalReview(params) {
  return request({
    url: "/v2/sec/contractDetail/approvalReview",
    method: "post",
    data: params
  });
}

export function approvalDestroyContract(params) {
  return request({
    url: "/v2/sec/contractDetail/approvalDestroyContract",
    method: "post",
    data: params
  });
}

export function uploadFile(params) {
  return request({
    url: "/v2/sec/contractDetail/uploadFile",
    method: "post",
    data: params
  });
}

export function approvalContract(params) {
  return request({
    url: "/v2/sec/contractDetail/approvalContract",
    method: "post",
    data: params
  });
}

export function rejectContract(params) {
  return request({
    url: "/v2/sec/contractDetail/rejectContract",
    method: "post",
    data: params
  });
}
